







import Vue from 'vue';
import NumInput from './NumInput.vue';

export default Vue.extend({
    name: 'wrapper-dimension',
    components: {
        NumInput,
    },
    props: {
        width: {
            type: Number,
            default: 25,
        },
        height: {
            type: Number,
            default: 40,
        },
    },
});
